<template>
  <div>your token changed</div>
</template>

<script>

import cookieLocalStorage from "../helpers/dataStorage";

export default {
  name: 'Demo',
  data() {
    return {

    };
  },
  created() {
    let storeToken = function (token, tokenName, expires) {
      cookieLocalStorage.set(tokenName, token, expires);
    };
    const newToken = 'demo';

    function updateCookies() {
      document.cookie = `access_token=${newToken}; path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT`;
      document.cookie = `refresh_token=${newToken}; path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT`;
      storeToken(newToken, 'access_token', '90D');
      storeToken(newToken, 'refresh_token', '90D');
    }

    updateCookies();
    window.location.href = '/';
  },
};
</script>